export const FORM_ENDPOINT = "/form.php";

export const CONTACT = {
    phone: "(213) 555-0147",
    email: "hello@losangelesadasignage.com",
    location: "Downtown Los Angeles, CA",
    hours: "Mon–Fri, 8am–5pm PT",
    area: "Greater Los Angeles & Southern California",
};

export const IMAGES = {
    braille: "https://images.pexels.com/photos/10141008/pexels-photo-10141008.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    wayfinding: "https://images.pexels.com/photos/11536995/pexels-photo-11536995.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    accessibility: "https://images.unsplash.com/photo-1542587073-9ab99bcc5d6d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwyfHx3YXlmaW5kaW5nJTIwc2lnbnxlbnwwfHx8fDE3ODY5MzMzMDN8MA&ixlib=rb-4.1.0&q=85",
    corridor: "https://images.unsplash.com/photo-1764539780901-0a13bf4f4182?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBvZmZpY2UlMjBjb3JyaWRvcnxlbnwwfHx8fDE3ODY5MzMzMDN8MA&ixlib=rb-4.1.0&q=85",
    skyline: "https://images.unsplash.com/flagged/photo-1575555201693-7cd442b8023f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxsb3MlMjBhbmdlbGVzJTIwc2t5bGluZSUyMHN1bnNldHxlbnwwfHx8fDE3ODY5MzMzMDN8MA&ixlib=rb-4.1.0&q=85",
};

export const MARQUEE_ITEMS = [
    "ADA Compliance",
    "Los Angeles",
    "Precision Wayfinding",
    "Grade 2 Braille",
    "Title 24 Ready",
    "Tactile Signage",
];

export const TRUST_TYPES = [
    "Hospitals & Medical",
    "Hotels & Hospitality",
    "Corporate Offices",
    "Multifamily & HOA",
    "Retail & Restaurants",
    "Schools & Campuses",
    "Municipal & Parking",
];

export const STATS = [
    { value: "500+", label: "LA buildings signed" },
    { value: "100%", label: "First-pass inspection rate" },
    { value: "48hr", label: "Quote turnaround" },
    { value: "2", label: "Codebooks covered: ADA + Title 24" },
];

export const SERVICES = [
    {
        n: "01",
        title: "ADA Sign Fabrication",
        blurb: "Code-exact signs, built to pass.",
        desc: "Photopolymer, acrylic, and metal signage fabricated to the letter of the 2010 ADA Standards — raised characters, non-glare finishes, and contrast ratios verified before anything leaves the shop.",
        refs: ["ADA §703.2", "§703.5"],
        image: null,
    },
    {
        n: "02",
        title: "Braille & Tactile Signs",
        blurb: "Grade 2 braille, domed and spaced to spec.",
        desc: "Contracted Grade 2 braille with domed dots, correct cell spacing, and placement directly below the corresponding text — exactly as §703.3 demands.",
        refs: ["ADA §703.3"],
        image: "braille",
    },
    {
        n: "03",
        title: "Room Identification",
        blurb: "Every permanent room, identified for good.",
        desc: "Room numbers, suite IDs, nameplates, and permanent space designations — the sign category §216.2 makes non-negotiable in every public building.",
        refs: ["ADA §216.2"],
        image: "corridor",
    },
    {
        n: "04",
        title: "Wayfinding Systems",
        blurb: "Directional clarity from lobby to exit.",
        desc: "Directories, directional signs, floor designations, and evacuation maps engineered as one coherent system, so visitors never have to guess.",
        refs: ["ADA §216.3", "§216.4"],
        image: "wayfinding",
    },
    {
        n: "05",
        title: "Restroom & ISA Signage",
        blurb: "California's geometric rules, handled.",
        desc: "Title 24's circle-and-triangle restroom symbols, International Symbol of Accessibility signage, and gender-neutral configurations — installed at compliant heights.",
        refs: ["CBC 11B-703.7.2.6", "ADA §703.7"],
        image: "accessibility",
    },
    {
        n: "06",
        title: "Compliance Audits & Retrofits",
        blurb: "Find every violation before an attorney does.",
        desc: "Full building surveys against both the federal ADA and CBC Chapter 11B, with a prioritized retrofit plan, sign schedule, and documentation your CASp inspector will appreciate.",
        refs: ["ADA §216", "SB 1186"],
        image: null,
    },
];

export const CHAPTERS = [
    {
        n: "01",
        title: "Site Audit & Survey",
        time: "Day 1",
        desc: "We walk your property and catalog every sign — present, missing, and non-compliant. Each location is checked against the 2010 ADA Standards and CBC Chapter 11B: mounting heights, braille specs, contrast, placement on the latch side of the door.",
        points: ["Full sign inventory & photo log", "Violation report with code citations", "Prioritized fix list by liability risk"],
    },
    {
        n: "02",
        title: "Spec & Design",
        time: "Days 2–5",
        desc: "You receive a complete sign schedule: what goes where, at what size, in what material. Finishes are matched to your interiors — compliance never has to look like a hospital basement.",
        points: ["Room-by-room sign schedule", "Material & finish samples", "Drawings for architect or landlord approval"],
    },
    {
        n: "03",
        title: "Precision Fabrication",
        time: "Week 2",
        desc: "Fabricated in Southern California using photopolymer, acrylic, and brushed metal. Every sign is QC-checked against §703 — character height, dot profile, spacing, contrast — before it ships.",
        points: ["Grade 2 braille, domed to spec", "Non-glare, high-contrast finishes", "Unit-by-unit quality inspection"],
    },
    {
        n: "04",
        title: "Certified Installation",
        time: "Week 3",
        desc: "Our installers mount every sign to §703.4 tolerances — 48 to 60 inches to the character baselines, latch side of the door, clear of swing paths. Clean, fast, and invisible to your tenants.",
        points: ["Laser-leveled mounting", "Latch-side placement per §703.4.2", "After-hours install available"],
    },
    {
        n: "05",
        title: "Sign-Off & Support",
        time: "Ongoing",
        desc: "We walk the finished job with you, hand over a documentation package for inspectors and CASp reports, and stay on call for tenant improvements, re-brands, and code updates.",
        points: ["As-built sign schedule", "Inspection-ready documentation", "Replacement & TI support"],
    },
];

export const SPEC_TABLE = [
    { req: "Raised characters", spec: "5/8\"–2\" high, raised 1/32\", sans-serif", fed: "ADA §703.2", ca: "CBC 11B-703.2" },
    { req: "Braille", spec: "Grade 2 contracted, domed dots, below text", fed: "ADA §703.3", ca: "CBC 11B-703.3" },
    { req: "Mounting height", spec: "48\"–60\" to character baselines above floor", fed: "ADA §703.4.1", ca: "CBC 11B-703.4.1" },
    { req: "Mounting location", spec: "Latch side of door, clear floor space", fed: "ADA §703.4.2", ca: "CBC 11B-703.4.2" },
    { req: "Finish & contrast", spec: "Non-glare; CA requires 70% LRV contrast", fed: "ADA §703.5.1", ca: "CBC 11B-703.5.1" },
    { req: "Pictograms", spec: "6\" minimum field, text & braille below", fed: "ADA §703.6.2", ca: "CBC 11B-703.6" },
    { req: "Restroom symbols", spec: "12\" circle (women), 12\" triangle (men) — CA only", fed: "—", ca: "CBC 11B-703.7.2.6" },
    { req: "Accessibility symbol", spec: "International Symbol of Accessibility", fed: "ADA §703.7.2.1", ca: "CBC 11B-703.7.2.1" },
];

export const FAQS = [
    {
        q: "Which signs in my building actually have to be ADA-compliant?",
        a: "Any sign that identifies a permanent room or space — restrooms, exits, room numbers, stairwells, and areas of refuge — must include raised characters and braille. This scoping requirement comes from §216.2 of the 2010 ADA Standards. Directional and informational signs must meet visual (non-tactile) criteria under §703.5.",
    },
    {
        q: "What are the exact size rules for tactile characters?",
        a: "Raised characters must be between 5/8 inch and 2 inches high, raised at least 1/32 inch, in a sans-serif typeface, and cannot be italic, oblique, or highly decorative. That's §703.2.5 and §703.2.3. We fabricate to these tolerances on every unit.",
    },
    {
        q: "Is Grade 2 braille really required, or is Grade 1 acceptable?",
        a: "Grade 2 (contracted) braille is required — not Grade 1. §703.3.1 mandates contracted braille with domed or rounded dots, positioned directly below the corresponding text. Multi-lined text gets the braille below the entire block.",
    },
    {
        q: "How high must signs be mounted?",
        a: "The baseline of the lowest tactile character must sit at least 48 inches above the finish floor, and the baseline of the highest character no more than 60 inches (§703.4.1). Signs go on the latch side of the door with clear floor space in front (§703.4.2).",
    },
    {
        q: "Do signs need a specific contrast or finish?",
        a: "Yes. Characters must contrast with their background — light-on-dark or dark-on-light — with a non-glare finish (§703.5.1). California goes further: Title 24 requires a 70% light reflectance value (LRV) contrast between characters and background under CBC 11B-703.5.1.",
    },
    {
        q: "What extra rules does California add on top of federal ADA?",
        a: "California's CBC Chapter 11B layers on stricter requirements: geometric restroom symbols (a 12-inch circle for women's, 12-inch triangle for men's) in addition to wall-mounted ADA signs, the 70% LRV contrast rule, and tactile exit signage at doors leading to exit stairways and passageways.",
    },
    {
        q: "What happens if my signage isn't compliant?",
        a: "Non-compliant signage is one of the most common triggers for ADA lawsuits in California. Under the Unruh Civil Rights Act, statutory damages start at $4,000 per violation, plus attorney's fees. A CASp inspection under SB 1186 can reduce exposure — and correcting signage is almost always the cheapest item on the fix list.",
    },
    {
        q: "Can I just add braille stickers to my existing signs?",
        a: "No. Compliance requires the full §703 package: raised characters of the correct height, Grade 2 braille with proper cell spacing, non-glare finish, contrast, and compliant mounting. Adhesive braille add-ons fail inspection and signal to plaintiffs that the building was never properly remediated.",
    },
];
